module.exports = __webpack_public_path__ + "img/agility_test_prepare.cd730cce.jpg";